import logo from "./logo.svg";
import "./App.css";
import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Dashboard from "./components/dashboard/dashboard";
import AttendanceList from "./components/attendance/attendance-list";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Discover from "./components/discover/discover-list";
import DiscoverBootStrap from "./components/discover/discover-list";
import DiscoverView from "./components/discover/discover-view";
import CreateBooking from "./components/discover/create-booking";
import MyBookingList from "./components/mybookings/mybooking-list";
import MyBookingView from "./components/mybookings/mybooking-view";
import Reschedule from "./components/discover/reschedule";
import OfficeList from "./components/offices/office-list";
import RoomList from "./components/rooms/room-list";
import UserList from "./components/users/user-list";
import ProfileView from "./components/profile/profile-view";
import Report from "./components/report/report";
import Dashboards from "./components/dashboards/dashboards";
import DiscoverModal from "./components/Modals/discoverModal";
import Header from "./components/common/Header";
import HelpQuestions from "./components/common/help";
import QuickReport from "./components/report/quickreport";
import RoomsView from "./components/rooms/roomsview";
import './components/rooms/roomview.css';

/* import RepeatModal from './components/Modals/repeatModal';
import RemainderModal from './components/Modals/remainderModal'; */

import Popup from "./assets/svg/chat-bot/Popup.svg";
import ChatBot from "./components/ChatBot/Popups";
import ChatGPTTypingEffect from "./components/ChatBot/ChatGPTTyping";
// import OpenAppRedirect from "./components/OpenAppRedirect";
import axios from "axios";
import { getCookie } from "./components/getcookie";

function App() {
  const [showChatBot, setShowChatBot] = useState(false);
  const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const environment = process.env.REACT_APP_ENVIRONMENT;
  useEffect(() => {
    const checkToken = async () => {
      try {
        console.log("🔍 Checking token validity...");

        const response = await axios.get(apiAdminUrl + "validatetoken", {
          headers: { Authorization: getCookie("mawalog") },
        });

        console.log("✅ Token status:", response.status);

        if (response.status === 401) {
          handleInvalidToken();
        }
      } catch (err) {
        console.error("❌ Token validation failed:", err);
        handleInvalidToken();
      }
    };

    const handleInvalidToken = () => {
      const currentURL = window.location.href;

      const redirectData = {
        redirectPath: currentURL,
        app: "meetq",
        ts: Date.now(),
      };

      console.warn("🔐 Saving redirect in window.name:", redirectData);

      // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
      window.name = JSON.stringify(redirectData);

      console.log("📌 window.name set:", window.name);

      // Clear token
      document.cookie =
        "mawalog=; path=/; domain=.mawalog.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";

      console.log("➡️ Redirecting to login:", `${accountsUrl}/login`);
      window.location.href = `${accountsUrl}/login`;
    };

    // 🔥 IMPORTANT: run once on load
    console.log("🚀 Initial token check");
    checkToken();

    // Recheck when tab regains focus
    const onFocus = () => {
      console.log("👁 Window focused → rechecking token");
      checkToken();
    };

    window.addEventListener("focus", onFocus);

    return () => window.removeEventListener("focus", onFocus);
  }, []);
  useEffect(() => {
    const channel = new BroadcastChannel(`auth_channel_mawalog_${environment}`);

    channel.onmessage = () => {
      window.location.reload();
    };

    return () => channel.close();
  }, []);



  return (
    <div className="App">
      <Header selectedTab={"Discover"} />

      <Routes>
        {/* <Route path='/mod' element={<RemainderModal />} /> */}
        <Route path="/reschedule" element={<Reschedule />} />
        <Route path="/modal" element={<DiscoverModal />} />
        <Route path="/mybooking-view" element={<MyBookingView />} />
        <Route path="/mybooking" element={<MyBookingList />} />
        <Route path="/book-meeting" element={<CreateBooking />} />
        <Route path="/" element={<DiscoverBootStrap />} />
        <Route path="/discover-view" element={<DiscoverView />} />
        <Route path="/attendance" element={<AttendanceList />} />
        <Route path="/office-list" element={<OfficeList />} />
        <Route path="/room-list" element={<RoomList />} />
        <Route path="/user-list" element={<UserList />} />
        <Route path="/profile" element={<ProfileView />} />
        <Route path="/report" element={<Report />} />
        <Route path="/dashboard" element={<Dashboards />} />
        <Route path="/help" element={<HelpQuestions />} />
        <Route path="/quick-report" element={<QuickReport />} />
        <Route path="/rooms/view" element={<RoomsView />} />
        {/* <Route path="/open" element={<OpenAppRedirect />} /> */}
      </Routes>

      {/* ChatBot Popup Icon */}
      <img
        src={Popup}
        width={"50px"}
        height={"50px"}
        onClick={() => {
          setShowChatBot(true);
        }}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          cursor: "pointer",
          background: "transparent",
        }}
        alt="mai"
      />

      {/* ChatBot Modal */}
      {showChatBot && (
        <ChatBot show={showChatBot} onHide={() => setShowChatBot(false)} />
      )}
    </div>
  );
}

export default App;
